var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Tabs',[_c('Tab',{attrs:{"title":"Active"}},[_c('ActiveFatigueDashboard')],1),_c('Tab',{attrs:{"title":"Next Night Rest"}},[_c('NightRestFatigueDashboard')],1),_c('Tab',{attrs:{"title":"Next Twenty Four Hour Rest"}},[_c('TwentyFourHourRestFatigueDashboard')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }